import { getLayoutByIdApi, LayoutResponseType } from '@app-store'
import { useEffect, useState } from 'react'
import { getEntityData } from '../../apis/entityData.api'

import { BVCasesType } from '../../types/pap.types'
import { EntityLayout, LayoutData } from '../../types/layout.types'
import FormRenderer from '../FormRenderer'
import { noop } from 'lodash'
import { MODE_CONSTANTS } from '@ui-kit'

const BVCases = ({ task }: BVCasesType) => {
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [layoutData, setLayoutData] = useState<LayoutData>()
  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByIdApi({
        entityId: task?.identifier?.layout_info?.childCase?.entity_id,
        layoutId: task?.identifier?.layout_info?.childCase?.layout_id,
      })
      if (res?.data) {
        setListingLayout(res.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchBVCase = async () => {
    try {
      const res = await getEntityData(
        task?.identifier?.layout_info?.childCase?.entity_name ?? '',
        Number(task?.identifier?.layout_info?.childCase?.entity_id),
        Number(task?.identifier?.layout_info?.childCase?.layout_id),
        task?.resource_id ?? ''
      )
      if (res?.data) {
        setLayoutData(res.data as LayoutData)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (task) {
      fetchListingLayout()
      fetchBVCase()
    }
  }, [task])

  return (
    <div>
      <FormRenderer
        heading={null}
        layout={listingLayout?.layout_data as LayoutData}
        mode={MODE_CONSTANTS?.VIEW}
        data={layoutData}
        handleFormSubmit={noop}
        fullLayout={listingLayout as EntityLayout}
      />
    </div>
  )
}

export default BVCases
